import { FacilityListParams, FacilitySort } from '@gyym/sdk'

/**
 * distance ソートは位置情報をブラウザで解決してから取得するため、
 * 緯度経度を持たない SSR の検索結果は prefetch しない。
 */
export const shouldPrefetchFacilitySearch = (params: FacilityListParams) =>
  params.sortBy !== FacilitySort.DISTANCE
